// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"673":"3027d4d1","734":"6546652d"}[chunkId] + ".js";
};